import React, { useContext, useEffect, useMemo, useState } from "react";
import OrgContext from "./orgContext";
import { ISearchContextObj } from "../types";

const SearchContext = React.createContext<ISearchContextObj>({
  searchText: "",
  disableSearch: false,
  setDisableSearch(): void {
    throw new Error("Function not implemented.");
  },
  selectedColumn: null,
  setSelectedColumn(): void {
    throw new Error("Function not implemented.");
  },
  setSearchText(): void {
    throw new Error("Function not implemented.");
  },
});

export const SearchProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { selectedOrg } = useContext(OrgContext);
  const [searchText, setSearchText] = useState<string>("");
  const [disableSearch, setDisableSearch] = useState(true);
  const [selectedColumn, setSelectedColumn] = useState<{
    id: string;
    value: string;
  } | null>(null);

  useEffect(() => {
    setSelectedColumn(null);
    setSearchText("");
    setDisableSearch(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrg]);

  const value = useMemo(
    () => ({
      searchText,
      disableSearch,
      setSearchText,
      setDisableSearch,
      selectedColumn,
      setSelectedColumn,
    }),
    [disableSearch, searchText, selectedColumn]
  );

  return (
    <SearchContext.Provider value={value}>{children}</SearchContext.Provider>
  );
};

export default SearchContext;
